const gu = {
  nav: {
    login: 'લૉગિન',
    bookNow: 'હમણાં બુક કરો',
    dashboard: 'ડેશબોર્ડ',
    back: 'પાછળ',
    home: 'હોમ',
  },
  landing: {
    heroTitle1: 'આકાશી સફર,',
    heroTitle2: 'હવે સરળ',
    heroSubtitle: 'ભારતનું અગ્રણી હેલિકોપ્ટર ચાર્ટર એગ્રિગેટર. ચકાસાયેલ ઓપરેટરો સાથે જોડાઓ, તરત જ ફ્લાઇટ બુક કરો.',
    bookYourFlight: 'તમારી ફ્લાઇટ બુક કરો',
    becomeOperator: 'ઓપરેટર બનો',
    whyChoose: 'AirYatra કેમ પસંદ કરવું?',
    verifiedOperators: 'ચકાસાયેલ ઓપરેટરો',
    verifiedOperatorsDesc: 'બધા ઓપરેટરો AOC પ્રમાણપત્રો, વીમો અને સલામતી પાલન સાથે સંપૂર્ણ ચકાસાયેલ છે.',
    bestPrices: 'શ્રેષ્ઠ કિંમતો',
    bestPricesDesc: 'AI-સંચાલિત કિંમત સૂચનો બહુવિધ ઓપરેટરો પાસેથી સ્પર્ધાત્મક ક્વોટ સુનિશ્ચિત કરે છે.',
    seamlessBooking: 'સરળ બુકિંગ',
    seamlessBookingDesc: 'ક્વોટ વિનંતીથી ડિજિટલ ટિકિટ સુધી, તમારી સંપૂર્ણ યાત્રા એક જ પ્લેટફોર્મ પર મેનેજ કરો.',
    flightsCompleted: 'પૂર્ણ થયેલ ફ્લાઇટ્સ',
    verifiedOperatorsStat: 'ચકાસાયેલ ઓપરેટરો',
    safetyRecord: 'સલામતી રેકોર્ડ',
    customerRating: 'ગ્રાહક રેટિંગ',
    premiumServices: 'પ્રીમિયમ સેવાઓ',
    elevateExperience: 'તમારો અનુભવ વધારો',
    premiumSubtitle: 'અમારી પ્રીમિયમ સભ્યપદ અને કોર્પોરેટ મુસાફરી ઉકેલો સાથે વિશિષ્ટ લાભો મેળવો',
    blackDesc: '20% સુધી ડિસ્કાઉન્ટ, પ્રાથમિકતા બુકિંગ, સમર્પિત પાયલોટ અને વિશિષ્ટ લાઉન્જ ઍક્સેસ સાથે પ્રીમિયમ સભ્યપદ.',
    priorityQueue: 'પ્રાથમિકતા બુકિંગ કતાર',
    dedicatedManager: 'સમર્પિત રિલેશનશિપ મેનેજર',
    freeCancellation: 'મફત રદ્દીકરણ',
    exploreMembership: 'સભ્યપદ જુઓ',
    corporateConsole: 'કોર્પોરેટ કન્સોલ',
    corporateDesc: 'મંજૂરી વર્કફ્લો, બજેટ અને એકીકૃત બિલિંગ સાથે એન્ટરપ્રાઇઝ માટે કેન્દ્રીકૃત મુસાફરી વ્યવસ્થાપન.',
    employeeManagement: 'કર્મચારી વ્યવસ્થાપન',
    budgetControls: 'બજેટ નિયંત્રણો',
    travelAnalytics: 'મુસાફરી વિશ્લેષણ',
    corporateRegistration: 'કોર્પોરેટ નોંધણી',
    documentVault: 'દસ્તાવેજ વૉલ્ટ',
    vaultDesc: 'DGCA દસ્તાવેજો, વીમો, લાઇસન્સ માટે સુરક્ષિત એન્ક્રિપ્ટેડ સ્ટોરેજ - સમાપ્તિ ચેતવણીઓ અને વર્ઝન નિયંત્રણ સાથે.',
    encryption: 'AES-256 એન્ક્રિપ્શન',
    expiryReminders: 'સમાપ્તિ રિમાઇન્ડર',
    secureSharing: 'સુરક્ષિત શેરિંગ',
    openVault: 'વૉલ્ટ ખોલો',
    loginToAccess: 'ઍક્સેસ માટે લૉગિન કરો',
    readyTakeOff: 'ઉડવા માટે તૈયાર?',
    ctaSubtitle: 'આજે જ તમારું હેલિકોપ્ટર ચાર્ટર બુક કરો અને ઉડ્ડયન શ્રેષ્ઠતાનો અનુભવ કરો.',
    startBooking: 'બુકિંગ શરૂ કરો',
    footerText: '© 2025 AirYatra. બધા હકો સુરક્ષિત. ભારતનું અગ્રણી હેલિકોપ્ટર ચાર્ટર પ્લેટફોર્મ.',
  },
  booking: {
    title: 'તમારી ફ્લાઇટ બુક કરો',
    subtitle: 'AirYatra - પ્રીમિયમ એર મોબિલિટી સેવાઓ',
    previous: 'પાછલું',
    next: 'આગળ',
    loginPrompt: 'બુકિંગ પૂછપરછ માટે કૃપા કરીને લૉગિન કરો',
    loginBtn: 'લૉગિન કરો',
    steps: {
      passengers: 'મુસાફરો',
      booking_type: 'બુકિંગ પ્રકાર',
      route: 'માર્ગ',
      price_inquiry: 'કિંમત',
    },
  },
  bookingForm: {
    selectAircraftType: 'વિમાનનો પ્રકાર પસંદ કરો',
    maxPassengers: 'મહત્તમ {{count}} મુસાફરો',
    adultPassengers: 'પુખ્ત મુસાફરો',
    male: 'પુરુષ',
    female: 'સ્ત્રી',
    totalAdults: 'કુલ પુખ્ત',
    children: 'બાળકો (4 વર્ષ સુધી)',
    childrenFree: 'મફત - મહત્તમ 2 બાળકો',
    flightType: 'ફ્લાઇટનો પ્રકાર',
    selectOption: '-- પસંદ કરો --',
    bookingFor: 'કોના માટે બુકિંગ',
    bookingPurpose: 'બુકિંગનો હેતુ',
    selected: 'પસંદ કરેલ',
    specifyPurpose: 'હેતુ જણાવો',
    pickupLocation: 'પિકઅપ સ્થળ',
    selectPickupPoint: 'પિકઅપ પોઇન્ટ પસંદ કરો',
    dropLocation: 'ડ્રોપ સ્થળ',
    selectDropPoint: 'ડ્રોપ પોઇન્ટ પસંદ કરો',
    estimatedDistance: 'અંદાજિત અંતર',
    villageDocsTitle: 'ગામ લેન્ડિંગ - દસ્તાવેજો જરૂરી',
    villageDocsDesc: 'ગામ/ખાનગી જમીન પર લેન્ડિંગ માટે તમારે Authority પાસેથી નીચેના દસ્તાવેજો લેવા પડશે:',
    villageDocsNote: 'બુકિંગ કન્ફર્મ થયા પછી, તમારે આ દસ્તાવેજો અપલોડ કરવા પડશે. Admin/Operator ચકાસશે, ત્યારે જ પાયલોટ ઉડાન ભરશે.',
    departureDate: 'પ્રસ્થાન તારીખ',
    pickupTime: 'પિકઅપ સમય',
    additionalOptions: 'વધારાના વિકલ્પો (વૈકલ્પિક)',
    waitingTime: 'રાહ જોવાનો સમય (મિનિટ)',
    waitingTimeNote: 'પ્રથમ 30 મિનિટ મફત, પછી ચાર્જ લાગુ',
    nightHalts: 'રાત્રિ રોકાણ',
    nightHaltsNote: 'ક્રૂ રહેઠાણ ચાર્જ સામેલ',
    bookingSummary: 'બુકિંગ સારાંશ',
    aircraftTypeLabel: 'વિમાન પ્રકાર:',
    totalPassengersLabel: 'કુલ મુસાફરો:',
    adults: 'પુખ્ત',
    childrenLabel: 'બાળકો',
    flightTypeLabel: 'ફ્લાઇટ પ્રકાર:',
    pickupLabel: 'પિકઅપ:',
    dropLabel: 'ડ્રોપ:',
    distanceLabel: 'અંતર:',
    dateTimeLabel: 'તારીખ અને સમય:',
    at: 'વાગ્યે',
    villageApprovalTitle: 'ગામ લેન્ડિંગ - એડમિન મંજૂરી જરૂરી',
    villageApprovalDesc: 'તમારી પૂછપરછ એડમિન મંજૂરી માટે મોકલવામાં આવશે. મંજૂરી પછી ચુકવણી શરૂ થશે.',
    priceBreakdown: 'કિંમત વિગતો',
    baseFlightCost: 'મૂળ ફ્લાઇટ ખર્ચ',
    flightCost: 'ફ્લાઇટ ખર્ચ',
    positioningCost: 'પોઝિશનિંગ ખર્ચ (ડેડ-લેગ)',
    roundTripDiscount: 'રાઉન્ડ ટ્રિપ છૂટ',
    operatorGrossCost: 'ઓપરેટર કુલ ખર્ચ',
    additionalCharges: 'વધારાના ચાર્જ',
    waitingGroundHolding: 'રાહ / ગ્રાઉન્ડ હોલ્ડિંગ',
    nightHalt: 'રાત્રિ રોકાણ ({{count}} રાત)',
    crewAccommodation: 'ક્રૂ રહેઠાણ અને ભોજન',
    fuelSurcharge: 'ઇંધણ સરચાર્જ',
    platformFees: 'પ્લેટફોર્મ ફી',
    convenienceFee: 'સુવિધા ફી',
    insurance: 'વીમો',
    peakSurge: 'પીક સીઝન સર્જ',
    platformCommission: 'પ્લેટફોર્મ કમિશન',
    included: 'સામેલ',
    helipadCharges: 'હેલિપેડ લેન્ડિંગ ચાર્જ',
    totalLandingCharges: 'કુલ લેન્ડિંગ ચાર્જ',
    taxableAmount: 'કરપાત્ર રકમ',
    totalGst: 'કુલ GST',
    grandTotal: 'કુલ રકમ',
    inclusiveTaxes: 'બધા કર સહિત',
    operatorReceives: 'ઓપરેટરને મળશે',
    specialRequirements: 'ખાસ જરૂરિયાતો (વૈકલ્પિક)',
    specialRequirementsPlaceholder: 'કોઈપણ ખાસ વિનંતીઓ અથવા જરૂરિયાતો...',
    submitting: 'મોકલી રહ્યાં છીએ...',
    submitApproval: 'મંજૂરી માટે મોકલો',
    generateInquiry: 'પૂછપરછ મોકલો',
    approvalNote: 'ગામ લેન્ડિંગ માટે એડમિન મંજૂરી જરૂરી છે.',
    inquiryNote: 'પૂછપરછ પછી, ઓપરેટરો તમને ક્વોટ મોકલશે.',
    formRestored: 'ફોર્મ ડેટા પુનઃસ્થાપિત!',
    selectAircraftError: 'કૃપા કરીને વિમાનનો પ્રકાર પસંદ કરો',
    minAdultError: 'ઓછામાં ઓછો 1 પુખ્ત મુસાફર જરૂરી',
    maxChildrenError: 'મહત્તમ 2 બાળકોની મંજૂરી',
    selectFlightTypeError: 'કૃપા કરીને ફ્લાઇટનો પ્રકાર પસંદ કરો',
    selectBookingForError: 'કોના માટે બુકિંગ છે તે પસંદ કરો',
    selectPurposeError: 'બુકિંગનો હેતુ પસંદ કરો',
    selectPickupError: 'પિકઅપ સ્થળ પસંદ કરો',
    selectDropError: 'ડ્રોપ સ્થળ પસંદ કરો',
    selectDateError: 'પ્રસ્થાન તારીખ પસંદ કરો',
    selectTimeError: 'પિકઅપ સમય પસંદ કરો',
    priceWaitError: 'કિંમતની ગણતરી થઈ નથી! કૃપા કરીને રાહ જુઓ',
    inquirySubmitted: 'પૂછપરછ સબમિટ થઈ! ઓપરેટરો જલ્દી જવાબ આપશે',
    noteVillageApproval: 'ગામ લેન્ડિંગ માટે એડમિન મંજૂરી જરૂરી',
    notePriceEngine: 'એવિએશન-ગ્રેડ પ્રાઇસિંગ એન્જિન દ્વારા ગણતરી',
    noteFinalPrice: 'અંતિમ કિંમત ઓપરેટર દ્વારા પુષ્ટિ થશે',
    docCollectorNoc: 'કલેક્ટર NOC',
    docFireDept: 'ફાયર વિભાગની પહોંચ',
    docPoliceStation: 'સ્થાનિક પોલીસ સ્ટેશનની પહોંચ',
    docSpDcp: 'SP/DCP પહોંચ',
  },
  options: {
    helicopter: 'હેલિકોપ્ટર',
    chartered_plane: 'ચાર્ટર્ડ પ્લેન',
    one_hour: '1 કલાકની ઉડાન',
    two_hour: '2 કલાકની ઉડાન',
    half_day: 'અડધો દિવસ',
    full_day: 'આખો દિવસ',
    multi_city: 'મલ્ટી-સિટી',
    point_to_point: 'પોઇન્ટ-ટુ-પોઇન્ટ',
    self: 'પોતાના માટે',
    friend_family: 'મિત્રો અને પરિવાર',
    company: 'કંપની / કોર્પોરેટ',
    political: 'રાજકીય / VIP',
    other: 'અન્ય',
    wedding: 'લગ્ન',
    temple_yatra: 'મંદિર યાત્રા',
    company_tour: 'કોર્પોરેટ ટૂર',
    election_tour: 'ચૂંટણી પ્રચાર',
    medical_emergency: 'મેડિકલ ઇમરજન્સી',
    film_shooting: 'ફિલ્મ શૂટિંગ',
    general_tour: 'સામાન્ય પ્રવાસ',
    pilgrimage: 'તીર્થયાત્રા',
    business: 'બિઝનેસ મીટિંગ',
  },
};

export default gu;
